const config = {
  development: {
    // base_url: "http://localhost:8080",
    base_url: "https://c9w3pqdatb.execute-api.us-east-1.amazonaws.com"
  },
  production: {
    // base_url: "https://api.kasikalecoute.com"
    base_url: "https://c9w3pqdatb.execute-api.us-east-1.amazonaws.com",
  },
};
export default config;
// module.exports = {
//     development: {
//       base_url: "http://localhost:8080"
//     },
//     test: {
//         base_url: "http://localhost:8080"
//     },
//     production: {
//       base_url: "http://quotabackend-env.eba-pinm2tpq.us-east-2.elasticbeanstalk.com"
//     },
//   };
